import {
  takeLatest,
  select,
  put,
} from 'redux-saga/effects';
import {
  SYNC_SET_ACTIVE_TAB_REQUEST,
  SYNC_SET_ACTIVE_TAB_SUCCESS,
  SYNC_SET_USER_STATE_REQUEST,
  SYNC_SET_USER_STATE_SUCCESS,
  SYNC_SET_ACTIVE_AUDIO_REQUEST,
  SYNC_SET_ACTIVE_AUDIO_SUCCESS,
} from '@/action-types/sync';

export function* setActiveTab(params: {
  activeTab: string;
}) {
  const state = yield select();
  const { sync } = state.book;

  if (state.breakpoint === 'mobile' || state.breakpoint === 'mobile-small') {
    yield put({
      type: SYNC_SET_ACTIVE_TAB_SUCCESS,
      data: {
        ...sync,
        activeTab: params.activeTab,
      },
      skip: true,
    });
  } else {
    yield put({
      type: SYNC_SET_ACTIVE_TAB_SUCCESS,
      data: {
        ...sync,
        activeTab: params.activeTab,
      },
    });
  }
}

export function* setUserState(params: {
  userRole: string;
  userState: {
    isConnected?: boolean;
    isError?: boolean;
    isViewingVocabulary?: boolean;
    mousePosition?: {
      x: number;
      y: number;
    };
    selectionPosition?: {
      range: {
        bottom: number;
        height: number;
        left: number;
        right: number;
        top: number;
        width: number;
      };
      top: number;
      left: number;
    };
  };
}) {
  const state = yield select();
  const syncState = state.book.sync || {};

  yield put({
    type: SYNC_SET_USER_STATE_SUCCESS,
    data: {
      ...syncState,
      [params.userRole]: {
        ...(syncState[params.userRole] || {}),
        ...params.userState,
      },
    },
  });
}

export function* setActiveAudio(params: {
  activeAudio: string;
}) {
  const state = yield select();

  yield put({
    type: SYNC_SET_ACTIVE_AUDIO_SUCCESS,
    data: {
      ...state.book.sync,
      activeAudio: params.activeAudio,
    },
  });
}

export default function* syncSaga() {
  yield takeLatest<{ type: string; } & any>(SYNC_SET_ACTIVE_TAB_REQUEST, setActiveTab);
  yield takeLatest<{ type: string; } & any>(SYNC_SET_USER_STATE_REQUEST, setUserState);
  yield takeLatest<{ type: string; } & any>(SYNC_SET_ACTIVE_AUDIO_REQUEST, setActiveAudio);
}
